import { useEffect, useState } from 'react';
import api from '@/lib/api';
import MobileShell from '@/components/MobileShell';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function AdminPayouts() {
  const [payouts, setPayouts] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [password, setPassword] = useState('');

  const load = () => {
    const q = filter ? `?status=${filter}` : '';
    api.get(`/admin/payouts${q}`).then(({ data }) => setPayouts(data.payouts || [])).catch(() => {});
  };

  useEffect(() => { load(); }, [filter]);

  const markPaid = async (id) => {
    try {
      await api.post(`/admin/payouts/${id}/paid`, { admin_id: 'admin', password });
      toast.success('Marked paid');
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed');
    }
  };

  return (
    <div className="resqly-shell">
      <div className="resqly-frame">
        <MobileShell title="Payments to be Made" header>
          <div className="px-5 py-5">
            <div className="flex gap-2 mb-4">
              {['pending', 'paid', ''].map((f) => (
                <button key={f || 'all'} className={`px-3 py-1 rounded text-sm border ${filter === f ? 'bg-blue-50 border-blue-300' : ''}`} onClick={() => setFilter(f)}>
                  {f || 'All'}
                </button>
              ))}
            </div>
            <input type="password" placeholder="Admin password" className="w-full border rounded p-2 mb-4" value={password} onChange={(e) => setPassword(e.target.value)} />
            <div className="space-y-3">
              {payouts.map((p) => (
                <div key={p.id} className="resqly-card p-3 text-sm" data-testid="payout-row">
                  <div className="font-medium">₹{p.amount} — {p.payout_type}</div>
                  <div className="text-slate-500">{p.recipient_type} {p.recipient_id}</div>
                  <div>Status: {p.status}</div>
                  {p.status === 'pending' && (
                    <Button size="sm" className="mt-2" onClick={() => markPaid(p.id)}>PAID</Button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </MobileShell>
      </div>
    </div>
  );
}
